import { zodResolver } from "@hookform/resolvers/zod";
import { t } from "@lingui/macro";
import { defaultExtracurricular, extracurricularSchema } from "@reactive-resume/schema";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
  RichInput,
} from "@reactive-resume/ui";
import { useForm } from "react-hook-form";
import { z } from "zod";

import { AiActions } from "@/client/components/ai-actions";
import { useResumeStore } from "@/client/stores/resume";

import { SectionDialog } from "../sections/shared/section-dialog";
import { MonthYearDatePicker } from "../sections/shared/month-year-date-picker";
import { URLInput } from "../sections/shared/url-input";
import { MastersUnionListEditor } from "../sections/masters-union-summary";

const formSchema = extracurricularSchema;

type FormValues = z.infer<typeof formSchema>;

export const ExtracurricularsDialog = () => {
  const form = useForm<FormValues>({
    defaultValues: defaultExtracurricular,
    resolver: zodResolver(formSchema),
  });

  const template = useResumeStore((state) => state.resume.data?.metadata?.template);
  const isMastersUnion = template === "mastersunion";

  return (
    <SectionDialog<FormValues>
      id="extracurriculars"
      form={form}
      defaultValues={defaultExtracurricular}
    >
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {/* <FormField
          name="organization"
          control={form.control}
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t`Organization`}</FormLabel>
              <FormControl>
                <Input {...field} placeholder="Club, society, or organization" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        /> */}

        {/* <FormField
          name="position"
          control={form.control}
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t`Position`}</FormLabel>
              <FormControl>
                <Input {...field} placeholder="Role or responsibility" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        /> */}

        {/* <FormField
          name="url"
          control={form.control}
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t`Website`}</FormLabel>
              <FormControl>
                <URLInput
                  {...field}
                  value={typeof field.value === "string" ? { label: field.value, href: "" } : field.value}
                  placeholder="https://www.example.com"
                  disableAutoHttps={true}
                  onChange={(value) => field.onChange(value)}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        /> */}

        {/* <FormField
          name="date"
          control={form.control}
          render={({ field }) => (
            <FormItem className="sm:col-span-2">
              <FormLabel>{t`Date or Date Range`}</FormLabel>
              <FormControl>
                <MonthYearDatePicker value={field.value} onChange={field.onChange} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        /> */}

        {/* <FormField
          name="location"
          control={form.control}
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t`Location`}</FormLabel>
              <FormControl>
                <Input {...field} placeholder="City, Country" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        /> */}

        <FormField
          name="summary"
          control={form.control}
          render={({ field }) => (
            <FormItem className="sm:col-span-2">
              <FormLabel>{t`Summary`}</FormLabel>
              <FormControl>
                {isMastersUnion ? (
                  <MastersUnionListEditor
                    value={field.value}
                    onChange={(value) => field.onChange(value)}
                  />
                ) : (
                  <RichInput
                    {...field}
                    content={field.value}
                    onChange={(value) => field.onChange(value)}
                    footer={(editor) => (
                      <AiActions
                        value={editor.getText()}
                        content={editor.getHTML()}
                        onChange={(value) => {
                          editor.commands.setContent(value);
                          field.onChange(value);
                        }}
                      />
                    )}
                  />
                )}
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </SectionDialog>
  );
};
